import { DynamicPrices } from "./store-types"

export const defaultPrices: DynamicPrices = {
  compareAtPrice: "",
  price: ""
}
